import { render, staticRenderFns } from "./Notarize.vue?vue&type=template&id=78f20238"
import script from "./Notarize.vue?vue&type=script&lang=js"
export * from "./Notarize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports